(function() {
  'use strict';

  const config = window.__collectionSearch || {};
  const STOREFRONT_TOKEN = "69f87c6fe77f6e2166cffa79b19b99a8";
  const COLLECTION_HANDLE = config.collectionHandle;
  const API_VERSION = '2024-01';

  if (!STOREFRONT_TOKEN || !COLLECTION_HANDLE) {
    console.warn('[CollectionSearch] Missing storefrontToken or collectionHandle');
    return;
  }

  // DOM refs
  const input = document.getElementById('collection-search-input');
  const btn = document.getElementById('collection-search-btn');
  const clearBtn = document.getElementById('collection-search-clear');
  const statusEl = document.getElementById('collection-search-status');
  const resultsContainer = document.getElementById('collection-search-results');

  // Main collection grid refs
  // Structure: results-list > .collection-wrapper > #ResultsList > div (container) > ul.product-grid
  const originalGrid = document.querySelector('ul.product-grid[ref="grid"]');
  const gridContainer = originalGrid ? originalGrid.parentElement : null; // the container div with inline-size

  if (!input) return;

  // State
  let allProducts = null;
  let loading = false;
  let searchGrid = null; // our injected grid element

  // --- API ---

  async function fetchAllProducts() {
    if (allProducts) return allProducts;
    if (loading) return [];
    loading = true;
    //showStatus('Produkte werden geladen...');

    let products = [];
    let cursor = null;
    let hasNext = true;

    try {
      while (hasNext) {
        const afterClause = cursor ? ', after: "' + cursor + '"' : '';
        const query = '{' +
          'collection(handle: "' + COLLECTION_HANDLE + '") {' +
            'products(first: 250' + afterClause + ', sortKey: TITLE) {' +
              'pageInfo { hasNextPage }' +
              'edges {' +
                'cursor ' +
                'node {' +
                  'id title handle vendor productType tags' +
                  ' featuredImage { url altText }' +
                  ' priceRange { minVariantPrice { amount currencyCode } }' +
                  ' compareAtPriceRange { minVariantPrice { amount currencyCode } }' +
                  ' images(first: 2) { edges { node { url altText } } }' +
                '}' +
              '}' +
            '}' +
          '}' +
        '}';

        var res = await fetch('/api/' + API_VERSION + '/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
          },
          body: JSON.stringify({ query: query })
        });

        var data = await res.json();
        var edges = data.data.collection.products.edges;
        products = products.concat(edges.map(function(e) { return e.node; }));
        hasNext = data.data.collection.products.pageInfo.hasNextPage;
        cursor = edges.length ? edges[edges.length - 1].cursor : null;
      }
    } catch (err) {
      console.error('[CollectionSearch] API error:', err);
      showStatus('Fehler beim Laden.');
      loading = false;
      return [];
    }

    allProducts = products;
    loading = false;
    hideStatus();
    console.log('[CollectionSearch] Loaded ' + products.length + ' products from "' + COLLECTION_HANDLE + '"');
    return products;
  }

  // --- Search ---

  function searchProducts(products, term) {
    var t = term.toLowerCase().trim();
    if (!t) return [];
    var words = t.split(/\s+/);
    return products.filter(function(p) {
      var haystack = [p.title, p.vendor, p.productType].concat(p.tags).join(' ').toLowerCase();
      return words.every(function(w) { return haystack.indexOf(w) !== -1; });
    });
  }

  // --- Render ---

  function formatPrice(amount) {
    return parseFloat(amount).toFixed(2).replace('.', ',') + ' €';
  }

  function renderResults(results, term) {
    if (!term.trim()) {
      // Clear search → restore original
      clearBtn.style.display = 'none';
      if (searchGrid) { searchGrid.remove(); searchGrid = null; }
      // Show original grid + siblings (infinite scroll spans, pagination)
      if (gridContainer) {
        Array.from(gridContainer.children).forEach(function(el) {
          if (el.dataset.searchInjected) return; // skip our elements
          el.style.display = '';
        });
      }
      if (resultsContainer) resultsContainer.style.display = 'none';
      return;
    }

    clearBtn.style.display = 'flex';

    // Hide original grid + infinite scroll spans + pagination
    if (gridContainer) {
      Array.from(gridContainer.children).forEach(function(el) {
        if (el.dataset.searchInjected) return;
        el.style.display = 'none';
      });
    }

    // Remove old search grid if exists
    if (searchGrid) { searchGrid.remove(); searchGrid = null; }

    // Build the search results
    var html = '';

    if (!results.length) {
      html = '<p class="search-no-results">Keine Ergebnisse für \u201E' + escapeHtml(term) + '\u201C in dieser Kollektion.</p>';
    } else {
      html += '<p class="search-result-count">' + results.length + ' Ergebnis' + (results.length !== 1 ? 'se' : '') + ' für \u201E' + escapeHtml(term) + '\u201C</p>';

      // Copy classes from original grid so theme styles apply
      var gridClasses = originalGrid ? originalGrid.className : 'product-grid';
      // Copy style but strip display:none (we set that ourselves)
      var gridStyle = originalGrid ? (originalGrid.getAttribute('style') || '') : '';
      gridStyle = gridStyle.replace(/display\s*:\s*none\s*;?/gi, '').trim();
      html += '<ul class="' + gridClasses + '" role="list" style="' + gridStyle + '">';

      results.forEach(function(p, i) {
        var img = p.featuredImage;
        var price = formatPrice(p.priceRange.minVariantPrice.amount);
        var compareAt = parseFloat(p.compareAtPriceRange.minVariantPrice.amount);
        var currentPrice = parseFloat(p.priceRange.minVariantPrice.amount);
        var isOnSale = compareAt > currentPrice;

        html += '<li class="product-grid__item product-grid__item--' + i + '">';
        html += '<a href="/products/' + p.handle + '" class="search-result-card">';
        if (img) {
          html += '<img src="' + img.url + '&width=400" alt="' + escapeHtml(img.altText || p.title) + '" loading="lazy">';
        } else {
          html += '<div class="search-result-card__no-image"></div>';
        }
        html += '<div class="search-result-card__info">';
        html += '<span class="search-result-card__title">' + escapeHtml(p.title) + '</span>';
        html += '<span class="search-result-card__price' + (isOnSale ? ' on-sale' : '') + '">';
        if (isOnSale) {
          html += '<s class="search-result-card__compare-price">' + formatPrice(compareAt) + '</s> ';
        }
        html += price + '</span>';
        html += '</div></a></li>';
      });

      html += '</ul>';
    }

    searchGrid = document.createElement('div');
    searchGrid.dataset.searchInjected = 'true';
    searchGrid.innerHTML = html;

    if (gridContainer) {
      gridContainer.appendChild(searchGrid);
    } else if (resultsContainer) {
      resultsContainer.innerHTML = html;
      resultsContainer.style.display = 'block';
    }
  }

  // --- Helpers ---

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function showStatus(msg) {
    if (statusEl) { statusEl.textContent = msg; statusEl.style.display = 'block'; }
  }

  function hideStatus() {
    if (statusEl) { statusEl.style.display = 'none'; }
  }

  function doSearch() {
    fetchAllProducts().then(function(products) {
      var results = searchProducts(products, input.value);
      renderResults(results, input.value);
    });
  }

  function clearSearch() {
    input.value = '';
    renderResults([], '');
    input.focus();
  }

  // --- Events ---

  input.addEventListener('focus', function() { fetchAllProducts(); }, { once: true });

  var debounceTimer;
  input.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(doSearch, 300);
  });

  btn.addEventListener('click', doSearch);
  clearBtn.addEventListener('click', clearSearch);

  input.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') { e.preventDefault(); doSearch(); }
    if (e.key === 'Escape') { clearSearch(); }
  });

})();